import React, { useEffect, useState } from "react";
import {useSelector} from 'react-redux'
import ReactDOM from 'react-dom'
import moment from 'moment';
import ReactTable from 'react-table';
import Button from "components/CustomButtons/Button.js";
import EmailIcon from '@material-ui/icons/Email';
import {CSVLink, CSVDownload} from 'react-csv';
import IconButton from '@material-ui/core/IconButton'
import SweetAlert from 'react-bootstrap-sweetalert'
import { refundUserReservation, refundPaymentIntent } from 'util/api/CheckoutAPI'
import {apiRequest} from 'util/api/util'

function RefundButton({paymentId, ...otherProps}) {

  const instructor = useSelector(state => state.instructor.instructor);

  const [alert, setAlert] = React.useState(null)

  const handleRefundClicked = (e) => {
    e.preventDefault()

    setAlert(
      <SweetAlert
      danger
      showCancel
      confirmBtnText="Yes, refund"
      confirmBtnBsStyle="danger"
      title="Are you sure?"
      onConfirm={() => {
        // dispatch(refundUserReservation(reservation.id))
        setAlert(false)
        refundPaymentIntent(paymentId, instructor.platformID)
          .then(response => {
            if (otherProps.success) {
              otherProps.success("processing")
            }
          })
        // refundUserReservation(reservationId)
        // setAlert(
        // <SweetAlert 
        // title={`Canceled`}
        // onConfirm={() => setAlert(false)}
        // onCancel={() => setAlert(false)}
        // >
        //   <div>Your class has been canceled. Thanks for letting us know!</div>
        //   <br></br>
        //   <div>If you purchased this class you will receive a refund in the next 3-5 days</div>
        // </SweetAlert>
        // )
      }
      }
      onCancel={() => setAlert(false)}
      focusCancelBtn
    >
      Are you sure you want to issue a refund?
      <br></br>
      <br></br>
      When a refund has been processed, the status of this payment will change from "succeeded" to "refunded"
    </SweetAlert>
    )

  }

  return (
    <>
      {alert}
      <button onClick={handleRefundClicked} className="btn btn-link _danger">Refund</button>
    </>
  )
}


function StripePaymentsTable(props) {

    const [payments, setPayments] = React.useState([])

    const currency = useSelector(state => state.instructor.instructor?.instructorProfile?.currency ?? "USD")
    const currencyFormatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency,
    });

    const updatePaymentId = (paymentId, message) => {
      const paymentIndex = payments.findIndex((val) => val.id === paymentId)
      var copyPayments = [...payments]
      copyPayments[paymentIndex] = {
        ...copyPayments[paymentIndex],
        status: message
      }

      setPayments(copyPayments)
    }

    const [isLoading, setIsLoading] = React.useState(false)
    const instructor = useSelector(state => state.instructor.instructor);
    useEffect(() => {

        if (!instructor || !instructor.platformID) {
            return;
        }

        
        apiRequest(`connect/updatePayments?partnerId=${instructor.platformID}`)
            .then(payments => {
                // console.log("updated")
                return apiRequest(`connect/payments?partnerId=${instructor.platformID}`)
            })
            .then(payments => {
                // setIsLoading(false)
                if (payments && payments.length > 0) {
                    setPayments(payments)
                }
                
                // console.log(payments)
                // console.log(payments.slice(11,15))
            })
            .catch(err => {
                console.log("error with payments 1: ", err)
            })

        setIsLoading(true)
        apiRequest(`connect/payments?partnerId=${instructor.platformID}`)
            .then(payments => {
                setIsLoading(false)
                if (payments && payments.length > 0) {
                    setPayments(payments)
                }
                
                // console.log(payments)
                // console.log(payments.slice(11,15))
            })
            .catch(err => {
                console.log("error with payments 2: ", err)
            })

    }, [instructor]);
    const data = payments.filter(val => {
      return val.status && (val.status === 'succeeded' || val.status === 'refunded' || val.status === 'processing')
    }).sort( (a, b) => {
        return b.created - a.created
    }).map(val => {
        var status = val.status ? val.status : "Unknown"
        if (val?.charges?.data && val.charges.data[0]) {
          status = val.charges.data[0].refunded ? "refunded" : status
        }

        return {
            id: val.id,
            date: val.created,
            student_name: val?.customerData?.firstName,
            email: val?.customerData?.email,
            status: status,
            //val.status ? val.status : "Unknown", 
            revenue: val.amount,
            class: {
                name: val.description,
                id: val.id,
                type: val.description
            },
            // class_time: val.objectSnapshot.start_time,
            
            // agree_to_marketing: (val.agreeToBeContacted === "true" || val.agreeToBeContacted === true) ? true : false,
            actions: status === "refunded" ? (<></>) : (
                // we've added some custom button actions
                <div className="actions-right">
                  <RefundButton paymentId={val.id} success={(message) => updatePaymentId(val.id, message)} />
                  {/* <IconButton style={{color: 'info'}} className="like" href={mailtoHref} target="_blank">
                    <EmailIcon />
                  </IconButton> */}
                </div>
              )
          };
    })

    function handleExport() {
      // moment(row.value * 1000).format('MMMM Do, h:mm a')
      // date, student_name, email, class_id, revenue, status
        const headers = [
          {label: "Date Purchased", key: "date_purchased"},
          {label: "Name", key: "student_name"},
          {label: "Email", key: "email"},
          {label: "Description", key: "description"},
          {label: "Sales", key: "sales"},
          {label: "Status", key: "status"}
        ]
        const cleanedData = data.map(val => {
          return {
            date_purchased: moment(val.date * 1000).toISOString(),
            student_name: val.student_name,
            email: val.email,
            description: val.class.type,
            sales: currencyFormatter.format(val.revenue / 100),
            status: val.status
          }
        })
        const element = (<CSVDownload data={cleanedData} headers={headers} target="_blank" />);
 
        ReactDOM.render(element, document.querySelector('#export-reservations-div'));
    }

    return (
      <div>
        <div className="d-flex flex-row-reverse">
          <Button onClick={handleExport} size={"sm"}>Export to CSV</Button>
          <div id='export-reservations-div'></div>
        </div>
        <ReactTable
                data={data}
                filterable
                loading={isLoading}
                columns={[
                  // {
                  //   Header: "Id",
                  //   accessor: "id"
                  //   },
                    {
                    Header: "Date Purchased",
                    accessor: "date",
                    // filterable: false,
                    sort: 'desc',
                    Cell: row => <span>{moment(row.value * 1000).format('MMMM Do, h:mm a')}</span>
                    },
                    // {
                    //   Header: "Class Time",
                    //   accessor: "class_time",
                    //   sort: 'class_time',
                    //   Cell: row => <span>{moment(row.value * 1000).format('MMMM Do, h:mm a')}</span>
                    // },
                    {
                    Header: "Name",
                    accessor: "student_name"
                    },
                    {
                    Header: "Email",
                    accessor: "email"
                    },
                    {
                    Header: "Description",
                    id: 'class_id',
                    accessor: c => c.class.type,
                    midWidth: 120
                    },
                    {
                    Header: "Sales",
                    accessor: "revenue",
                    Cell: row => {
                        if (row.value > 0) {
                            return (<span>{currencyFormatter.format(row.value / 100)}</span>);
                        } else {
                            return (<span></span>);
                        }
                    },
                    width: 80
                    },
                    {
                    Header: "Status",
                    accessor: "status",
                    width: 100
                    },
                    {
                    Header: "Actions",
                    accessor: "actions",
                    width: 100
                    }
                ]}
                defaultPageSize={10}
                showPaginationTop={false}
                showPaginationBottom={true}
                className="-highlight"
                />
        </div>
    );
}

export default StripePaymentsTable;